// assets
import DashboardIcon from "@mui/icons-material/Dashboard";

// constant
const icons = { DashboardIcon };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: "dashboard",
  title: "Dashboard",
  type: "group",
  children: [
    {
      id: "dashboardContent",
      title: "Dashboard",
      type: "item",
      url: "/",
      icon: icons.DashboardIcon,
      breadcrumbs: false,
      guardName: "Dashboard"
    }
    // {
    //   id: "default",
    //   title: "Dashboard",
    //   type: "item",
    //   url: "/dashboard/default",
    //   icon: icons.IconDashboard,
    //   breadcrumbs: false,
    //   guardName: undefined,
    // },
  ]
};

export default dashboard;
